import * as React from 'react';
import type { ChipProps } from '@components/moleculs/chip/types';
import { Chip as BaseChip } from '@mui/material';
import { styled } from 'styled-components';

import { CloseIcon } from '../../icons';

import { ChipContainer } from './styles';

const Molecule: React.FC<ChipProps> = ({
    deleteIcon = <CloseIcon className='delete-icon' />,
    ...rest
}) => (
    <ChipContainer>
        <BaseChip deleteIcon={deleteIcon} {...rest} />
    </ChipContainer>
);

export const Chip = styled(Molecule)({});
